import { useQuery } from '@tanstack/react-query';
import { mapToCurrentBalance, memberInfoKey, requestMyMemberInfo } from './memberInfoApi';

/**
 * The member's real outstanding/credit/paid balance and its due date. Shares the `myMemberInfo`
 * query/cache with {@link useMemberAutoPaySummary}/{@link useMemberBillingProfile} — same key,
 * different `select` — so mounting this alongside `AutoPayCard` doesn't fire a second request.
 * Returns the full query result (not just `data`/`isLoading`) so callers get `error`/`refetch` for
 * the card's interim error state without a second, redundant `useQuery` call.
 */
export function useCurrentBalance() {
  return useQuery({
    queryKey: memberInfoKey,
    queryFn: requestMyMemberInfo,
    select: mapToCurrentBalance,
  });
}
